import React, { FC } from 'react'
import { useGetPatientQuery } from '../../../core/api/patientApi'
import { Breadcrumb } from 'antd'
import { getPatientDataFormated } from '../../../helpers/patientDataManipulations'
import './index.less'
import Intro from './component/Intro'
import { SpinLoader } from '../../common/SpinLoader'
import { skipToken } from '@reduxjs/toolkit/query'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Consultations } from './component/Consultations'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface PatientProfile {
  patientId: string | undefined
}

export const PatientProfile: FC<PatientProfile> = ({ patientId }) => {
  const { data: patient, isLoading: patientIsLoading, isFetching: patientIsFetching, isSuccess: patientIsLoaded } = useGetPatientQuery(patientId ?? skipToken)
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const { userNameOneString } = getPatientDataFormated(patient, t, currentLanguage)

  if (patientIsLoading || patientIsFetching || !patientIsLoaded) {
    return <SpinLoader />
  }

  return (
    <div className="patientProfile">
      <Breadcrumb
        items={[
          {
            title: (
              <Link to="/patients" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <ArrowLeftOutlined />
                <span>{t('header.pages.patients')}</span>
              </Link>
            ),
          },
          {
            title: userNameOneString,
          },
        ]}
      />
      <Intro patient={patient} />
      <Consultations patient={patient} />
    </div>
  )
}
